module.exports = __webpack_public_path__ + "img/logo.37789c5a.png";